import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=a9be00aa&scoped=true&"
import script from "./addModel.vue?vue&type=script&lang=js&"
export * from "./addModel.vue?vue&type=script&lang=js&"
import style0 from "./addModel.vue?vue&type=style&index=0&id=a9be00aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be00aa",
  null
  
)

export default component.exports